import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export const ConfirmationDialog = (props: { open: boolean, handleConfirm: () => void, handleClose: () => void, message: string, confirmButtonText?: string, cancelButtonText?: string }) => {
    const { t } = useTranslation();


    const handleConfirm = () => {
        props.handleConfirm();
        props.handleClose();
    }

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            >
            <DialogTitle>{t('confirmationDialog.warning')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                {props.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose} color="primary">
                {props.cancelButtonText ?? t('confirmationDialog.cancel')}
                </Button>
                <Button onClick={handleConfirm} color="primary" autoFocus>
                {props.confirmButtonText ?? t('confirmationDialog.confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}